import React from "react";
import { MainContainer } from "../Components/Elements";
import LegacyFinanceNotice from "../Components/LegacyFinanceNotice";

const SellerFinance = () => (
  <MainContainer>
    <LegacyFinanceNotice />
  </MainContainer>
);

export default SellerFinance;
